import React, { useState } from 'react'
import { format, parseISO } from 'date-fns'
import { saveAs } from 'file-saver'

import { Loader } from 'semantic-ui-react'
import { Button } from '@wework/dieter-ui'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import { DownloadPlan } from '../Icons'

const DATE_FORMAT = {
  DATE: 'yyyy-MM-dd',
  datetime: 'MMM dd, yyyy HH:mm (xxx)',
}

interface Props {
  url?: string
  name?: string
  last_updated?: string
  buildingName?: string
  extension: string
  tooltipText?: string
  snackBars: any
}

function DownloadButton({
  url,
  name,
  last_updated,
  buildingName,
  extension,
  tooltipText,
  snackBars,
}: Props) {
  const [downloading, setDownloading] = useState(false)
  // const useStyles = makeStyles({
  //   spinner: {
  //     color: '#FFF',
  //   },
  // })

  function downloadPlan() {
    if (!url) {
      return
    }
    setDownloading(true)
    const fileDate = last_updated
      ? format(parseISO(last_updated), DATE_FORMAT.DATE)
      : format(new Date(), DATE_FORMAT.DATE)

    fetch(url, { credentials: 'same-origin' })
      .then(resp => {
        if (resp.status !== 200) {
          throw new Error()
        }
        return resp.blob()
      })
      .then(blob => {
        let floorName = name ? `${name}-` : ''
        saveAs(blob, `${buildingName}-${floorName}${fileDate}.${extension}`)
        setDownloading(false)
      })
      .catch(e => {
        setDownloading(false)
        snackBars.addAlert({
          text: `There was a problem starting the download.`,
          variant: 'error',
        })
      })
  }

  return (
    <Button
      data-tooltip={tooltipText ? tooltipText : null}
      data-position="top right"
      onClick={downloadPlan}
      style={{
        borderRadius: 4,
        background: 'transparent',
        height: 32,
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
      }}
      data-testid="building-info-button"
      disabled={!url || downloading}
    >
      {downloading ? (
        // <CircularProgress size={20} className={classes.spinner} />
        <Loader
          active
          inverted
          size="small"
          style={{ position: 'relative', marginTop: 6 }}
        />
      ) : (
        <DownloadPlan />
      )}
    </Button>
  )
}

export default withSnackbar(DownloadButton)
